// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
// index.js
// 注意babel-polyfill会影响打包大小，非常影响性能， 20200228-wuwg，
// 解决方案可以参考doc>问题处理文档>babel-polyfill太大问题.md
import 'babel-polyfill';
import Vue from 'vue';
import App from './App';
import router from './router';
import '@com.thunisoft.artery/artery-ui/dist/styles/artery-ui.css';
import ArteryUI from '@com.thunisoft.artery/artery-ui';
import * as echarts from 'echarts';

// 全局组件
import './components/common/index.js';
// 全局指令
import './js/app/directive/fdDirective.js';
// 全局过滤器
import './js/app/filter/fdFilter.js';
// 全局消息
import './js/app/message/fdMessage.js';
// 全局配置
import './js/config.js';
// 全局方法类
import '@/components/index.js';

import FdGlobal from './js/app/common/fdGlobal.js';
import eventHandler from '@/components/tools/extend/event.js';

import './css/index.less';

// 全局对象
window.fdGlobal = new FdGlobal();
Vue.use(ArteryUI);
window.echarts = echarts;
window.eventHandler = eventHandler;

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    components: {App},
    template: '<App/>'
});
